export default {"src":"/_next/static/media/Sons_Logo.cfa6b3ca.svg","height":297,"width":955,"blurWidth":0,"blurHeight":0};